module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.locked ? "index-articles locked" : "index-articles"
  }, [(!_vm.items.length) ? [_vm._v("\n\t\t" + _vm._s(_vm.data.nothing_to_show) + "\n\t")] : [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "cols s_24 m___12"
    }, [_c('div', {
      staticClass: "articleItem"
    }, [_c('a', {
      staticClass: "imgContainer",
      style: (("background-image: url(\"" + (item.image_src) + "\")")),
      attrs: {
        "href": item.detail_link
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "rSide"
    }, [(item.section) ? _c('a', {
      staticClass: "section",
      attrs: {
        "href": item.section.link
      }
    }, [_vm._v(_vm._s(item.section.name))]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "description",
      attrs: {
        "href": item.detail_link
      }
    }, [_vm._v(_vm._s(item.header))]), _vm._v(" "), _c('p', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "bottomInfo"
    }, [(item.date) ? _c('p', {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.date))]) : _vm._e(), _vm._v(" "), (item.seen) ? _c('p', {
      staticClass: "seen"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.seen) + "\n\t\t\t\t\t\t\t\t"), _c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
      }
    })])]) : _vm._e(), _vm._v(" "), (item.comments) ? _c('p', {
      staticClass: "comments"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.comments) + "\n\t\t\t\t\t\t\t\t"), _c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 0h24v24H0V0z",
        "fill": "none"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"
      }
    })])]) : _vm._e()])])])])
  }), 0)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5c06d4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/lists/index-articles.vue
// module id = 405
// module chunks = 14